import React from 'react';
import posthog from 'posthog-js';
import { BRAND, TOKENS, RADIUS, FONT_BODY } from '../lib/theme.js';

// BRAND.md §8.6 / §10: every rebuilt section is wrapped so one runtime error
// degrades to a branded fallback panel instead of white-screening the shop.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const section = this.props.name || 'section';
    console.error(`[ErrorBoundary:${section}]`, error, info?.componentStack);
    posthog.capture('ui_error_caught', { section });
    posthog.captureException(error, { section });
  }

  render() {
    if (!this.state.error) return this.props.children;
    if (this.props.fallback !== undefined) return this.props.fallback;

    const ar = this.props.lang === 'ar';
    return (
      <div role="alert" style={{
        background: TOKENS.sageWash, border: `1px solid ${TOKENS.line}`,
        borderRadius: RADIUS.md, padding: 24, margin: '12px 0',
        textAlign: 'center', fontFamily: FONT_BODY, color: TOKENS.ink,
      }}>
        <div style={{ fontWeight: 600, marginBottom: 6 }}>
          {ar ? 'حدث خطأ في هذا الجزء' : 'This section hit a problem'}
        </div>
        <div style={{ fontSize: 14, color: TOKENS.inkMuted, marginBottom: 14 }}>
          {ar ? 'باقي الصفحة يعمل بشكل طبيعي.' : 'The rest of the page still works.'}
        </div>
        <button
          onClick={() => this.setState({ error: null })}
          style={{
            padding: '10px 20px', borderRadius: RADIUS.sm, border: 'none',
            background: BRAND.forest, color: '#fff', cursor: 'pointer',
            fontSize: 14, fontWeight: 600, fontFamily: FONT_BODY, minHeight: 44,
          }}
        >
          {ar ? 'إعادة المحاولة' : 'Try again'}
        </button>
      </div>
    );
  }
}
